import { Components } from './styled';
import { getTextFromSelectedItems, SearchDropdownItem } from '../../hooks/useSearchDropdown';
import React from 'react';

const ProjectPicker = ({
  dropdownProps,
  notSetText,
}: {
  dropdownProps: {
    show: (event: React.MouseEvent<unknown, MouseEvent>) => void;
    selectedItems: SearchDropdownItem[];
  };
  notSetText?: string;
}) => {
  return (
    <Components.Picker onClick={(e) => dropdownProps.show(e)}>
      {dropdownProps?.selectedItems && dropdownProps?.selectedItems?.length > 0 ? (
        <Components.PickerLabel>{getTextFromSelectedItems(dropdownProps?.selectedItems)}</Components.PickerLabel>
      ) : (
        <Components.NotSetLabel>{notSetText || 'Not set'}</Components.NotSetLabel>
      )}
      <Components.PickerIconWrapper>
        <Components.PickerIcon />
      </Components.PickerIconWrapper>
    </Components.Picker>
  );
};
export default ProjectPicker;
